import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FileUploader } from 'ng2-file-upload';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { UploadService } from '../../services/upload.service';
import { ArquivoPropostaService } from 'src/app/services/arquivo-proposta.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { VariaveisArquivoPropostaModalComponent } from '../variaveis-arquivo-proposta-modal/variaveis-arquivo-proposta-modal.component';
import swal from 'sweetalert2';

enum TipoArquivo {
  Orcamento = 'orcamento',
  Pedido = 'pedido'
}

// jquery
declare const $: any;

@Component({
  selector: 'app-arquivo-proposta-modal',
  templateUrl: './arquivo-proposta-modal.component.html',
  styleUrls: ['./arquivo-proposta-modal.component.scss']
})
export class ArquivoPropostaModalComponent implements OnInit {
  uploadForm: FormGroup;

  public config: PerfectScrollbarConfigInterface = {};

  uploader = new FileUploader({
    isHTML5: true
  });

  enviarArquivo: string;
  arquivosProposta = {
    orcamento: false,
    pedido: false
  };

  idLoja;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialogRef: MatDialogRef<ArquivoPropostaModalComponent>,
    private uploadService: UploadService,
    private fb: FormBuilder,
    private arquivoPropostaService: ArquivoPropostaService,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.idLoja) {
      this.idLoja = data.idLoja;
    }
  }

  ngOnInit(): void {
    this.uploadForm = this.fb.group({
      document: [null, [Validators.required]]
    });
    this.buscarArquivosProposta();
  }

  buscarArquivosProposta() {
    this.carregandoService.mostra('buscarArquivosProposta');

    this.arquivoPropostaService.consultarArquivosProposta(this.idLoja).subscribe(
      (arquivosProposta) => {
        this.arquivosProposta = arquivosProposta;
        this.carregandoService.esconde('buscarArquivosProposta');
      },
      (erro) => {
        this.carregandoService.esconde('buscarArquivosProposta');
        this.notificacaoService.erro(erro);
      }
    );
  }

  limparEnvio() {
    this.enviarArquivo = undefined;
    this.uploader.clearQueue();
    this.uploader.queue = [];
    this.uploadForm = this.fb.group({
      document: [null, [Validators.required]]
    });

    this.buscarArquivosProposta();
  }

  baixarModelo() {
    this.carregandoService.mostra('baixarModelo');
    this.arquivoPropostaService.baixarModelo().subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, 'Modelo_Proposta.docx');
        this.carregandoService.esconde('baixarModelo');
      },
      (erro) => {
        this.carregandoService.esconde('baixarModelo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  baixarArquivo(tipo) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoPropostaService.baixarPorTipo(tipo, this.idLoja).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, 'proposta_' + tipo + '.docx');
        this.carregandoService.esconde('baixarArquivo');
      },
      (erro) => {
        this.carregandoService.esconde('baixarArquivo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  excluirArquivo(tipo) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Arquivo de proposta de ' + (tipo === 'orcamento' ? 'Orçamento?' : 'Pedido?'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirArquivo');
        this.arquivoPropostaService.excluirPorTipo(tipo, this.idLoja).subscribe(
          () => {
            this.notificacaoService.sucesso('Arquivo de proposta excluído com sucesso!!');

            this.limparEnvio();

            this.carregandoService.esconde('excluirArquivo');
          },
          (erro) => {
            this.carregandoService.esconde('excluirArquivo');
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  uploadSubmit() {
    for (let i = 0; i < this.uploader.queue.length; i++) {
      let fileItem = this.uploader.queue[i]._file;
      if (fileItem.size > 10000000) {
        alert('Cada arquivo deve possuir no máximo 10 MB.');
        return;
      }
    }

    let data = new FormData();

    for (let j = 0; j < this.uploader.queue.length; j++) {
      let fileItem = this.uploader.queue[j]._file;
      data.append('file', fileItem);
      data.append('fileSeq', 'seq' + j);
    }

    this.carregandoService.mostra('enviaArquivo');

    this.arquivoPropostaService.enviarArquivoProposta(this.enviarArquivo, data, this.idLoja).subscribe(
      (resp: any) => {
        this.notificacaoService.sucesso('Arquivo Enviado com Sucesso!!!');
        this.carregandoService.esconde('enviaArquivo');
        this.limparEnvio();
      },
      (erro) => {
        this.carregandoService.esconde('enviaArquivo');
        this.notificacaoService.erro(erro);
      }
    );

    this.uploader.clearQueue();
  }

  abrirModalVariaveis() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(VariaveisArquivoPropostaModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
